import CancelButton from './CancelButton'
import SaveButton from './SaveButton'
import {useNavigate} from 'react-router-dom'

export const EditActionWrapper = () => {
  const history = useNavigate()

  const handleClick = () => {
    history(-1)
  }

  return (
    <div className='d-flex justify-content-end align-items-center flex-row mt-5'>
      <CancelButton onClick={handleClick} title='Cancel' />
      <SaveButton />
    </div>
  )
}

export default EditActionWrapper
